/**
 * Format number toLocaleString.
 * @param value
 * @returns
 */
export function toLocaleString(value) {
  return isNaN(value) ? 0 : value.toLocaleString();
}

/**
 * Shorten long file name with file extension.
 * @param fileName
 * @returns
 */
export const shortenFileName = fileName => {
  let name = fileName.substr(0, fileName.lastIndexOf('.')) || fileName;
  const extension = fileName.substr(fileName.lastIndexOf('.') + 1);
  if (name.length > 20) {
    name = name.substring(0, 20) + '...';
  }
  return name + '.' + extension;
};
